import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { formItem } from '../preview-forms.interface';


@Component({
    selector: 'app-form-long',
    templateUrl: './form-long.component.html',
    styleUrls: ['./form-long.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormLongComponent {
  form!: formItem;
  @Output('valid') valid = new EventEmitter()
  @Output('update') update = new EventEmitter()
  @Input('model') set item(v: formItem) {
    this.form = v
  }

  updateValue(v: any) {
    this.update.emit(v.value)
  }

  updateValiDate(e: any) {
    this.valid.emit(e)
  }
}
